import axios from "axios";

export default axios.create({
  baseURL: `https://staging.api.a1tutor.org/v1/`,
});
